// extracted by mini-css-extract-plugin
module.exports = {"modal":"Popup_modal__q9ZV0","videoLink":"Popup_videoLink__aLWiK"};